import { Folder, FolderPlus, Loader2 } from "lucide-react";
import { useDriveBrowse } from "../../hooks/useDrive";

export function DriveFolderPicker({ value, onChange }) {
  const { data, isLoading, isError } = useDriveBrowse("");
  const folders = (data?.entries || []).filter((e) => e.is_dir);

  return (
    <div className="space-y-1.5 max-h-56 overflow-y-auto rounded-lg border border-border p-1.5">
      <button
        type="button"
        data-testid="drive-folder-none"
        onClick={() => onChange(null)}
        className={`w-full flex items-center gap-2 rounded-md px-2.5 py-2 text-sm text-left transition-colors ${
          value === null
            ? "bg-emerald-500/10 text-emerald-500 border border-emerald-500/20"
            : "hover:bg-muted border border-transparent"
        }`}
      >
        <FolderPlus className="h-4 w-4 shrink-0" />
        <span>Ninguna — crear proyecto nuevo (se genera su carpeta)</span>
      </button>

      {isLoading && (
        <div className="flex items-center gap-2 px-2.5 py-2 text-xs text-muted-foreground">
          <Loader2 className="h-3.5 w-3.5 animate-spin" /> Leyendo carpetas de Drive...
        </div>
      )}
      {isError && (
        <p className="px-2.5 py-2 text-xs text-destructive">No se pudo leer la carpeta SISTEMAS.</p>
      )}

      {folders.map((f) => (
        <button
          key={f.name}
          type="button"
          data-testid={`drive-folder-${f.name}`}
          onClick={() => onChange(f.name)}
          className={`w-full flex items-center gap-2 rounded-md px-2.5 py-2 text-sm text-left transition-colors ${
            value === f.name
              ? "bg-emerald-500/10 text-emerald-500 border border-emerald-500/20"
              : "hover:bg-muted border border-transparent"
          }`}
        >
          <Folder className="h-4 w-4 shrink-0" />
          <span className="truncate">{f.name}</span>
        </button>
      ))}
    </div>
  );
}
